export function ComponentsDao(XRAY_RESOURCE, XRayUIDaoFactory) {
    return XRayUIDaoFactory()
        .setPath(XRAY_RESOURCE.COMPONENTS + '/:action')
        .setCustomActions({
            'search': {
                method: 'POST',
                params: {action: 'search'}
            },
            'paginSearch': {
                method: 'POST',
                params: {action: 'paginatedsearch'}

            },
            'getChildren': {
                method: 'POST',
                params: {action: 'navigator'},
                isArray: true
            },
            'getDetails': {
                method: 'POST',
                params: {action: 'details'},
                notifications: true
            },
            'getData': {
                method: 'POST',
                params: {action: 'data'}
            },
            'getRoot': {
                method: 'GET',
                params: {action: 'rootComponents'},
                isArray: true

            },
            'getComponentIssues': {
                method: 'POST',
                params: {action: 'issueDetails'}
            },
            'getLicense': {
                method: 'POST',
                path: XRAY_RESOURCE.COMPONENTS + '/details/licenses'
            },
            'getIssues': {
                method: 'POST',
                path: XRAY_RESOURCE.COMPONENTS + '/details/issues'
            },
            'getIssuesNew': {
                method: 'POST',
                path: XRAY_RESOURCE.COMPONENTS + '/details/userIssues'
            },
            'getUserIssuesNew': {
                method: 'POST',
                path: XRAY_RESOURCE.COMPONENTS + '/details/issues/new'
            },
            'getIssuesPaginated': {
                method: 'POST',
                path: XRAY_RESOURCE.COMPONENTS + '/details/paginatedIssues'
            },
            'getUserWatchIssuesPaginated': {
                method: 'POST',
                path: '/userIssues/details'
            },
            'getUserWatchLicensesIssuesPaginated': {
                method: 'POST',
                path: '/userIssues/details'
            },
            'ignoreOnceUserWatchIssues': {
                method: 'POST',
                path: '/ignoreRules',
                notifications: true
            },
            'ignoreAllUserWatchIssues': {
                method: 'POST',
                path: '/ignoreRules/allIssues',
                notifications: true
            },
	        'getRecentUserIssues': {
		        method: 'GET',
		        path: '/userIssues/recent',
		        isArray: true
	        },
            'getFiles': {
                method: 'POST',
                params: {action: 'resources'},
                isArray: true
            },
            'getFilesInfo': {
                method: 'POST',
                path: XRAY_RESOURCE.COMPONENTS + '/details/files',
                isArray: true
            },
            'getGeneral': {
                method: 'POST',
                path: XRAY_RESOURCE.COMPONENTS + '/details/general'
            },
            'getInternalVersions': {
                method: 'POST',
                path: XRAY_RESOURCE.COMPONENTS + '/details/internalVersions'
            },
            'getPublicVersions': {
                method: 'POST',
                path: XRAY_RESOURCE.COMPONENTS + '/details/publicVersions'
            },
            'getInfoTabs': {
                method: 'POST',
                path: XRAY_RESOURCE.COMPONENTS + '/details/tabs'
            },
            'getAboutBox': {
                method: 'POST',
                isArray: true,
                params: {action: 'aboutBox'}

            },
            'exportAboutBox': {
                method: 'POST',
                params: {action: 'exportAboutBox'}

            },
            'exportAboutBoxNew': {
                method: 'GET',
                params: {action: 'exportAboutBox'}

            },



        })
        .getInstance();
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/components_dao.js